import classNames from 'classnames'
import React, { FC, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import { FullFight } from 'web/data/models'
import { GenerateNoteOptions } from 'web/data/setup-note-exporter'
import { ModalContainerProps } from '../_ModalContainer'
import { ExportNoteTab } from './ExportNoteTab'
import { PlaintextFightOutlineTab } from './PlaintextFightOutlineTab'
import { ShareFightTab } from './ShareFightTab'
import { WAAssignmentsTab } from './WAAssignmentsTab'

export type TabbedExportModalProps = {
    title: string

    share: {
        fightAndSetupString?: string
        fightOnlyString: string
    }

    note?: {
        generateNoteString: (params: GenerateNoteOptions) => string
        generateWaArString: () => string
    }

    plaintext: {
        fullFight: FullFight
    }
}

enum TabTypes {
    "exportNote",
    "waAssignments",
    "share",
    "plaintextOutline"
}

type Props = TabbedExportModalProps & ModalContainerProps

export const TabbedExportModal: FC<Props> = ({
    title, closeSelf, share, note, plaintext
}) => {

    const [tab, setTab] = useState<TabTypes>(
        note
            ? TabTypes.exportNote
            : TabTypes.share
    )

    return (
        <Modal
            isOpen
            fade={false}
            toggle={closeSelf}
            backdrop={"static"}
            size="lg"
        >
            <ModalHeader>
                {title}
            </ModalHeader>

            <ModalBody className="bg-light">

                <Nav tabs className="small">
                    <NavItem>
                        <NavLink
                            disabled={note == null}
                            tabIndex={0}
                            onClick={() => setTab(TabTypes.exportNote)}
                            onKeyPress={((e) => {
                                if (e.key === " " || e.key === "Enter") {
                                    setTab(TabTypes.exportNote)
                                }
                            })}
                            className={classNames(
                                { "active": tab === TabTypes.exportNote }
                            )}
                        >
                            {"Generate in-game note"}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            disabled={note == null}
                            tabIndex={0}
                            onClick={() => setTab(TabTypes.waAssignments)}
                            onKeyPress={((e) => {
                                if (e.key === " " || e.key === "Enter") {
                                    setTab(TabTypes.waAssignments)
                                }
                            })}
                            className={classNames(
                                { "active": tab === TabTypes.waAssignments }
                            )}
                        >
                            {"Personal timers"}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            tabIndex={0}
                            onClick={() => setTab(TabTypes.share)}
                            onKeyPress={((e) => {
                                if (e.key === " " || e.key === "Enter") {
                                    setTab(TabTypes.share)
                                }
                            })}
                            className={classNames(
                                { "active": tab === TabTypes.share }
                            )}
                        >
                            {"Share fight & setup"}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            tabIndex={0}
                            onClick={() => setTab(TabTypes.plaintextOutline)}
                            onKeyPress={((e) => {
                                if (e.key === " " || e.key === "Enter") {
                                    setTab(TabTypes.plaintextOutline)
                                }
                            })}
                            className={classNames(
                                { "active": tab === TabTypes.plaintextOutline }
                            )}
                        >
                            {"Plaintext fight outline"}
                        </NavLink>
                    </NavItem>
                </Nav>

                <TabContent activeTab={tab} className="bg-white p-3 border border-top-0">
                    {note &&
                        <>
                            <TabPane tabId={TabTypes.exportNote}>
                                <ExportNoteTab generateNoteString={note.generateNoteString} />
                            </TabPane>

                            <TabPane tabId={TabTypes.waAssignments}>
                                <WAAssignmentsTab generateWaArString={note.generateWaArString} />
                            </TabPane>

                        </>
                    }
                    <TabPane tabId={TabTypes.plaintextOutline}>
                        <PlaintextFightOutlineTab fullFight={plaintext.fullFight} />
                    </TabPane>

                    <TabPane tabId={TabTypes.share}>
                        <ShareFightTab
                            fightAndSetupString={share.fightAndSetupString}
                            fightOnlyString={share.fightOnlyString}
                        />
                    </TabPane>
                </TabContent>

            </ModalBody>

            <ModalFooter className="d-flex justify-content-end space-mx-2" >
                <Button
                    outline
                    size="sm"
                    onClick={closeSelf}
                    title={"Close (esc)"}
                >
                    {"Close"}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

